import { PureComponent, ReactNode } from 'react';
import Hotkeys from 'react-hot-keys';
import { motion } from 'framer-motion';

type Props = {
    closeMe: () => void;
};

export class ImproveSmartReportDialog extends PureComponent<Props> {
    render(): ReactNode {
        return (
            <Hotkeys keyName="esc">
                <motion.div
                    initial={{ opacity: 0 }}
                    exit={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    style={{ zIndex: 20 }}
                    transition={{ duration: 0.2, ease: 'linear' }}
                    className="font-lato select-none"
                >
                    <div className="modal-overlay" onClick={this.props.closeMe}></div>
                    <div className="modal-content w-736 max-h-4/5 font-lato font-400 overflow-scroll">
                        <div className="pl-40 pr-20 py-16 flex items-center justify-between bg-white sticky top-0 z-50">
                            <p className="text-16 font-700">Improve Extraction Result</p>
                            <svg
                                className="w-10 h-20 fill-darwin-neutral-1000 cursor-pointer"
                                viewBox="0 0 12 12"
                                xmlns="http://www.w3.org/2000/svg"
                                onClick={this.props.closeMe}
                            >
                                <path d="M10.75 9.75L7.03125 6L10.75 2.28125C11.0625 2 11.0625 1.53125 10.75 1.25C10.4688 0.9375 10 0.9375 9.71875 1.25L6 4.96875L2.25 1.25C1.96875 0.9375 1.5 0.9375 1.21875 1.25C0.90625 1.53125 0.90625 2 1.21875 2.28125L4.9375 6L1.21875 9.75C0.90625 10.0312 0.90625 10.5 1.21875 10.7812C1.5 11.0938 1.96875 11.0938 2.25 10.7812L6 7.0625L9.71875 10.7812C10 11.0938 10.4688 11.0938 10.75 10.7812C11.0625 10.5 11.0625 10.0312 10.75 9.75Z" />
                            </svg>
                        </div>
                        <div className="bg-darwin-neutral-50 p-16">
                            <div className="mb-16 bg-white py-16 rounded-8">
                                <p className="text-14 font-700 text-darwin-neutral-900 text-center mb-16">
                                    When clicking a photo of a report:{' '}
                                </p>
                                <div className="flex justify-center space-x-16">
                                    <div className="w-160 px-10 py-16 bg-darwin-accent-symptoms-blue-100 rounded-4">
                                        <div className="w-52 h-52 m-auto mb-16 flex items-center justify-center bg-darwin-accent-symptoms-blue-200 rounded-full">
                                            <div className="border-2 border-darwin-accent-symptoms-blue-800">
                                                <svg
                                                    className="w-16 h-16 fill-darwin-accent-symptoms-blue-800 transform scale-150"
                                                    viewBox="0 0 24 24"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M3 4C3.26522 4 3.51957 3.89464 3.70711 3.70711C3.89464 3.51957 4 3.26522 4 3C4 2.73478 3.89464 2.48043 3.70711 2.29289C3.51957 2.10536 3.26522 2 3 2C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3C2 3.26522 2.10536 3.51957 2.29289 3.70711C2.48043 3.89464 2.73478 4 3 4ZM21 22C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21C22 20.7348 21.8946 20.4804 21.7071 20.2929C21.5196 20.1054 21.2652 20 21 20C20.7348 20 20.4804 20.1054 20.2929 20.2929C20.1054 20.4804 20 20.7348 20 21C20 21.2652 20.1054 21.5196 20.2929 21.7071C20.4804 21.8946 20.7348 22 21 22Z"
                                                        stroke="#2188FF"
                                                        stroke-width="2.5"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                </svg>
                                            </div>
                                        </div>
                                        <p className="text-13 text-darwin-neutral-800 text-center">
                                            Position the edges of the report within the camera frame
                                        </p>
                                    </div>

                                    <div className="w-160 px-10 py-16 bg-darwin-accent-symptoms-blue-100 rounded-4">
                                        <div className="w-52 h-52 m-auto mb-16 flex items-center justify-center bg-darwin-accent-symptoms-blue-200 rounded-full">
                                            <svg
                                                className="w-24 h-24 fill-darwin-accent-symptoms-blue-800"
                                                viewBox="0 0 18 19"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path d="M12.4375 14.5H14.3516C14.0781 13.0547 13.5312 11.6875 12.8281 10.4375L11.2266 11.4141C11.7734 12.3516 12.2031 13.4062 12.4375 14.5ZM10.5234 10.3594L12.125 9.38281C11.3047 8.21094 10.2891 7.19531 9.11719 6.375L8.14062 7.97656C9.03906 8.64062 9.85938 9.46094 10.5234 10.3594ZM16.5 15.75H2.75V2C2.75 1.33594 2.16406 0.75 1.5 0.75C0.796875 0.75 0.25 1.33594 0.25 2V17C0.25 17.7031 0.796875 18.25 1.5 18.25H16.5C17.1641 18.25 17.75 17.7031 17.75 17C17.75 16.3359 17.1641 15.75 16.5 15.75ZM8.0625 5.67188C6.8125 4.96875 5.44531 4.42188 4 4.14844V6.0625C5.09375 6.29688 6.14844 6.72656 7.08594 7.27344L8.0625 5.67188Z" />
                                            </svg>
                                        </div>
                                        <p className="text-13 text-darwin-neutral-800 text-center">
                                            Make sure the camera is not tilted or at an angle while
                                            clicking
                                        </p>
                                    </div>

                                    <div className="w-160 px-10 py-16 bg-darwin-accent-symptoms-blue-100 rounded-4">
                                        <div className="w-52 h-52 m-auto mb-16 flex items-center justify-center bg-darwin-accent-symptoms-blue-200 rounded-full">
                                            <svg
                                                className="w-24 h-24 fill-darwin-accent-symptoms-blue-800"
                                                viewBox="0 0 22 21"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path d="M12.25 6.86719V0.5H9.75V6.86719C5.21875 7.41406 1.625 10.9297 1 15.3438C0.882812 16.0859 1.50781 16.75 2.25 16.75H19.7109C20.4531 16.75 21.0781 16.0859 20.9609 15.3438C20.3359 10.9297 16.7422 7.41406 12.25 6.86719ZM11 20.5C12.3672 20.5 13.5 19.4062 13.5 18H8.5C8.5 19.4062 9.59375 20.5 11 20.5Z" />
                                            </svg>
                                        </div>
                                        <p className="text-13 text-darwin-neutral-800 text-center">
                                            Ensure that the report is well lit and there’s no
                                            shadows
                                        </p>
                                    </div>
                                </div>

                                <div className="h-1 bg-darwin-neutral-100 my-24"></div>

                                <div className="flex m-8">
                                    <div className="w-60p">
                                        <p className="flex justify-center items-center space-x-8 mb-16">
                                            <span>
                                                <svg
                                                    className="w-14 h-20 fill-darwin-accent-green-800"
                                                    viewBox="0 0 14 15"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path d="M7 0.75C3.11719 0.75 0 3.89453 0 7.75C0 11.6328 3.11719 14.75 7 14.75C10.8555 14.75 14 11.6328 14 7.75C14 3.89453 10.8555 0.75 7 0.75ZM10.1445 6.54688L6.64453 10.0469C6.50781 10.2109 6.31641 10.2656 6.125 10.2656C5.90625 10.2656 5.71484 10.2109 5.57812 10.0469L3.82812 8.29688C3.52734 7.99609 3.52734 7.53125 3.82812 7.23047C4.12891 6.92969 4.59375 6.92969 4.89453 7.23047L6.125 8.43359L9.07812 5.48047C9.37891 5.17969 9.84375 5.17969 10.1445 5.48047C10.4453 5.78125 10.4453 6.24609 10.1445 6.54688Z" />
                                                </svg>
                                            </span>
                                            <span className="font-700 text-14 text-darwin-neutral-900">
                                                Correct
                                            </span>
                                        </p>
                                        <div className="flex justify-center space-x-8">
                                            <div className="w-108 h-145">
                                                <img
                                                    src="/images/image1.jpeg"
                                                    alt="image 1"
                                                    className="w-full h-full"
                                                />
                                            </div>
                                            <div className="w-108 h-145">
                                                <img
                                                    src="/images/image2.jpg"
                                                    alt="image 2"
                                                    className="w-full h-full"
                                                />
                                            </div>
                                            <div className="w-108 h-145">
                                                <img
                                                    src="/images/image5.png"
                                                    alt="image 3"
                                                    className="w-full h-full"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-40p">
                                        <p className="flex justify-center items-center space-x-8 mb-16">
                                            <span>
                                                <svg
                                                    className="w-14 h-20 fill-darwin-status-warning-500"
                                                    viewBox="0 0 14 15"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path d="M7 0.75C3.11719 0.75 0 3.89453 0 7.75C0 11.6328 3.11719 14.75 7 14.75C10.8555 14.75 14 11.6328 14 7.75C14 3.89453 10.8555 0.75 7 0.75ZM9.89844 10.1836C10.1172 10.457 10.0898 10.8672 9.81641 11.1133C9.70703 11.2227 9.54297 11.25 9.40625 11.25C9.21484 11.25 9.02344 11.1953 8.88672 11.0312L7 8.78906L5.08594 11.0312C4.94922 11.1953 4.75781 11.25 4.56641 11.25C4.42969 11.25 4.29297 11.2227 4.15625 11.1133C3.88281 10.8672 3.85547 10.457 4.07422 10.1836L6.125 7.75L4.07422 5.34375C3.85547 5.07031 3.88281 4.66016 4.15625 4.41406C4.42969 4.19531 4.83984 4.22266 5.08594 4.49609L7 6.73828L8.88672 4.49609C9.13281 4.22266 9.54297 4.19531 9.81641 4.41406C10.0898 4.66016 10.1172 5.07031 9.89844 5.34375L7.84766 7.75L9.89844 10.1836Z" />
                                                </svg>
                                            </span>
                                            <span className="font-700 text-14 text-darwin-neutral-900">
                                                Incorrect
                                            </span>
                                        </p>
                                        <div className="flex justify-center space-x-8">
                                            <div className="w-108 h-145">
                                                <img
                                                    src="/images/image3.jpeg"
                                                    alt="image 4"
                                                    className="w-full h-full"
                                                />
                                            </div>
                                            <div className="w-108 h-145">
                                                <img
                                                    src="/images/image4.jpg"
                                                    alt="image 5"
                                                    className="w-full h-full"
                                                />
                                            </div>{' '}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <p className="text-12 font-700 text-darwin-neutral-500">
                                Currently we don’t support all tests - the team is working hard to
                                support extraction of new tests every day.{' '}
                                <span className="text-darwin-primary-500 cursor-pointer">
                                    <a
                                        href="https://ekacare.notion.site/Supported-Lab-tests-for-linking-graphs-by-MR-pipeline-df5a38fbfc4745329cd44ccede036ac4"
                                        target="_blank"
                                    >
                                        Check Supported Tests
                                    </a>
                                </span>
                            </p>
                        </div>
                    </div>
                </motion.div>
            </Hotkeys>
        );
    }
}
